<ion-button (click)="openDurationComponent()" [fill]="'clear'" class="date-filter">
  {{ dateDs }}
</ion-button>
